import { scrollHeader } from "./components/header";
import { siteNav } from "./components/nav";
import { embedMedia } from "./components/embedMedia";
import { filterScroll } from "./components/filterScroll";
import { draggableSlider } from "./components/slider";

scrollHeader();
siteNav();
embedMedia();
filterScroll();
draggableSlider();
